export default __webpack_public_path__ + "static/media/servicegradient.cc27f6c5.png";